module.exports = __webpack_public_path__ + "img/red_058.0b431579.png";